// firebase-config.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase config object (from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyA8FNm0c7AuBbwL5waVq6q0UoKGI7KRZpY",
    authDomain: "chat2s-e6493.firebaseapp.com",
    projectId: "chat2s-e6493",
    storageBucket: "chat2s-e6493.appspot.com",
    messagingSenderId: "480651435058",
    appId: "1:480651435058:web:914ba5ecbdc09ca7d1302b",
    //measurementId: "G-03K1PSRY5T"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
